import React from 'react';
import Skeleton from 'react-loading-skeleton';

const MicroFrontendContainer = ({
    MicroFrontend,
    history,
    data,
    name,
    height,
    skeletonId,
    refresh,
    skeletonHeight = '100%',
    width = '100%',
    removeAbsolutePosition,
    className = '',
    containerPosition = 'relative',
    isSideNav,
}) => {
    const position = removeAbsolutePosition ? 'relative' : 'absolute';

    const skeletonStyleContainer = {
        width,
        height,
        position,
    };

    return (
        <>
            <div style={{ position: containerPosition }}>
                <div
                    id={skeletonId}
                    className={className}
                    style={skeletonStyleContainer}
                >
                    <Skeleton
                        className='skeleton'
                        height={skeletonHeight}
                        width="100%"
                        style={{ zIndex: 50 }}
                    />
                </div>
                {!isSideNav && (
                    <MicroFrontend
                        refresh={refresh}
                        name={name}
                        history={history}
                        data={data}
                    />
                )}
            </div>
            {isSideNav && (
                <MicroFrontend
                    refresh={refresh}
                    name={name}
                    history={history}
                    data={data}
                />
            )}
        </>
    );
};

export default MicroFrontendContainer;
